import { SxProps, Theme } from '@mui/material'

export const wrapperSx: SxProps<Theme> = {
  margin: 0,
  width: 'max-content',
  display: 'flex',
}

export const radioSx: SxProps<Theme> = { width: '2rem', height: '2rem' }

export const labelSx: SxProps<Theme> = {
  fontWeight: 400,
  marginLeft: '1rem',
  letterSpacing: '0.044rem',
}
